import { createApp } from "vue";
import Cookies from "js-cookie";
import "default-passive-events";
import ElementPlus from "element-plus";
// 中文语言
import locale from 'element-plus/es/locale/lang/zh-cn'
import "@/assets/styles/index.scss"; // global css
import App from "./App";
import store from "./store";
import router from "./router";
import directive from "./directive"; // directive
// 注册指令
import plugins from "./plugins"; // plugins
import { download } from "@/utils/request";

// svg图标
// import 'virtual:svg-icons-register'
import SvgIcon from "@/components/SvgIcon";
import elementIcons from "@/components/SvgIcon/svgicon";
import "./assets/icons"; // icon
import "./permission"; // permission control
import { useDict } from "@/utils/dict";
import {
  addDateRange,
  handleTree,
  parseTime,
  resetForm,
  selectDictLabel,
  selectDictLabels,
} from "@/utils/sunrise.js";

// 分页组件
import Pagination from "@/components/Pagination";
// 自定义表格工具组件
import RightToolbar from "@/components/RightToolbar";
// 文件上传组件
import FileUpload from "@/components/FileUpload";
// 图片上传组件
import ImageUpload from "@/components/ImageUpload";
// 图片预览组件
import ImagePreview from "@/components/ImagePreview";
// 自定义树选择组件
import TreeSelect from "@/components/TreeSelect";
// 字典标签组件
import DictTag from "@/components/DictTag";
//引入指令
import instructions from "@/assets/js/instructions.js";
//引入波纹按钮
import corrugationButton from "@/components/corrugationButton";
//图片文件前缀
import { FILTER_URL } from "@/utils/request.js";
//横向滚动组件
import rowScroll from "@/components/rowScroll/index.vue";
//标题卡组件
//横向滚动组件
import head from "@/components/head/index.vue";

const app = createApp(App);

for (const key in instructions) {
  app.directive(
    instructions[key].name,
    instructions[key][instructions[key].name]
  );
}

// 全局方法挂载
app.config.globalProperties.useDict = useDict;
app.config.globalProperties.download = download;
app.config.globalProperties.parseTime = parseTime;
app.config.globalProperties.resetForm = resetForm;
app.config.globalProperties.handleTree = handleTree;
app.config.globalProperties.addDateRange = addDateRange;
app.config.globalProperties.selectDictLabel = selectDictLabel;
app.config.globalProperties.selectDictLabels = selectDictLabels;
app.config.globalProperties.FILTER_URL = FILTER_URL;

// 全局组件挂载
app.component("DictTag", DictTag);
app.component("Pagination", Pagination);
app.component("TreeSelect", TreeSelect);
app.component("FileUpload", FileUpload);
app.component("ImageUpload", ImageUpload);
app.component("ImagePreview", ImagePreview);
app.component("RightToolbar", RightToolbar);
app.component("bwButton", corrugationButton);
app.component("rowScroll", rowScroll);
app.component("headTitle", head);

app.use(router);
app.use(store);
app.use(plugins);
app.use(elementIcons);
app.component("svg-icon", SvgIcon);

directive(app);

// 使用element-plus 并且设置全局的大小
app.use(ElementPlus, {
  locale: locale,
  // 支持 large、default、small
  size: Cookies.get("size") || "default",
});

app.mount("#app");
